import { StepLetterSheets, type StepLetterView } from "@ncp/ui";
import type { ToolConfirmation } from "../types";

/**
 * The letters a staged move or task sends, carried on its confirmation card in full as the server rendered them (release 1.6): the officer reads
 * them before confirming, and the confirmation is refused if they are no longer those letters.
 */
export function stagedLetters(c: ToolConfirmation): StepLetterView[] {
  const letters = c.arguments._letters;
  return Array.isArray(letters) ? (letters as StepLetterView[]) : [];
}

export function StagedLetters({ confirmation, className }: { confirmation: ToolConfirmation; className?: string }) {
  const letters = stagedLetters(confirmation);
  return letters.length ? <StepLetterSheets preview={{ letters, shown: true, fingerprint: null, loading: false, error: null }} className={className} /> : null;
}
